export const INTEGRATION_ACCOUNTS_LIST_REQUEST = 'INTEGRATION_ACCOUNTS_LIST_REQUEST'
export const INTEGRATION_ACCOUNTS_LIST_SUCCESS = 'INTEGRATION_ACCOUNTS_LIST_SUCCESS'
export const INTEGRATION_ACCOUNTS_LIST_ERROR = 'INTEGRATION_ACCOUNTS_LIST_ERROR'
export const INTEGRATION_ACCOUNTS_LIST_SET = 'INTEGRATION_ACCOUNTS_LIST_SET'

export const DELETE_INTEGRATION_ACCOUNTS_REQ = 'DELETE_INTEGRATION_ACCOUNTS_REQ'
export const DELETE_INTEGRATION_ACCOUNTS_REQ_SUCCESS = 'DELETE_INTEGRATION_ACCOUNTS_REQ_SUCCESS'
export const DELETE_INTEGRATION_ACCOUNTS_REQ_ERROR = 'DELETE_INTEGRATION_ACCOUNTS_REQ_ERROR'

export const CLOUD_ACCOUNTS_LIST_REQUEST = 'CLOUD_ACCOUNTS_LIST_REQUEST'
export const CLOUD_ACCOUNTS_LIST_SUCCESS = 'CLOUD_ACCOUNTS_LIST_SUCCESS'
export const CLOUD_ACCOUNTS_LIST_ERROR = 'CLOUD_ACCOUNTS_LIST_ERROR'
export const CLOUD_ACCOUNTS_LIST_SET = 'CLOUD_ACCOUNTS_LIST_SET'

export const DELETE_CLOUD_ACCOUNTS_REQ = 'DELETE_CLOUD_ACCOUNTS_REQ'
export const DELETE_CLOUD_ACCOUNTS_REQ_SUCCESS = 'DELETE_CLOUD_ACCOUNTS_REQ_SUCCESS'
export const DELETE_CLOUD_ACCOUNTS_REQ_ERROR = 'DELETE_CLOUD_ACCOUNTS_REQ_ERROR'

export const PAUSE_INTEGRATION_ACCOUNTS_REQ = 'PAUSE_INTEGRATION_ACCOUNTS_REQ'
export const PAUSE_INTEGRATION_ACCOUNTS_REQ_SUCCESS = 'PAUSE_INTEGRATION_ACCOUNTS_REQ_SUCCESS'
export const PAUSE_INTEGRATION_ACCOUNTS_REQ_ERROR = 'PAUSE_INTEGRATION_ACCOUNTS_REQ_ERROR'

export const KUBERNETES_ACCOUNTS_LIST_REQUEST = 'KUBERNETES_ACCOUNTS_LIST_REQUEST'
export const KUBERNETES_ACCOUNTS_LIST_SUCCESS = 'KUBERNETES_ACCOUNTS_LIST_SUCCESS'
export const KUBERNETES_ACCOUNTS_LIST_ERROR = 'KUBERNETES_ACCOUNTS_LIST_ERROR'
export const KUBERNETES_ACCOUNTS_LIST_SET = 'KUBERNETES_ACCOUNTS_LIST_SET'

export const INTEGRATION_ACCOUNT_VIEW_PREFERENCES_REQ = 'INTEGRATION_ACCOUNT_VIEW_PREFERENCES_REQ'
export const SAVE_INTEGRATION_ACCOUNT_VIEW_PREFERENCES = 'SAVE_INTEGRATION_ACCOUNT_VIEW_PREFERENCES'

export const ALERT_INTEGRATION_VIEW_PREFERENCES_REQ = 'ALERT_INTEGRATION_VIEW_PREFERENCES_REQ'
export const SAVE_ALERT_INTEGRATION_VIEW_PREFERENCES = 'SAVE_ALERT_INTEGRATION_VIEW_PREFERENCES'



// WEBPACK FOOTER //
// ./src/store/modules/integration_accounts/integration-accounts.type.js